import { Component, computed, EventEmitter, inject, input, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContextService } from 'app/core/services';
import { ButtonComponent, IButtonConfig } from 'shared/components/atoms/button/button.component';
import { ButtonColor, ButtonSize } from 'shared/enums';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  imports: [FormsModule, MatIcon, ButtonComponent, TranslateModule, MatInputModule, MatIconButton],
  styles: `
    :host {
      ::ng-deep .mat-mdc-form-field-subscript-wrapper {
        display: none !important;
      }
    }
  `,
})
export class ContentHeaderComponent implements OnChanges {
  protected readonly translateService = inject(TranslateService);
  protected readonly contextService = inject(ContextService);

  @Input() public configuration?: IContentHeaderConfig;
  @Output() public search = new EventEmitter<string>();
  public defaultConfig = {
    searchPlaceholder: this.translateService.instant(`global.quickSearch`),
    buttons: [],
  };
  @Input() public searchText = '';
  public hideSearch = input(false);
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonColor = ButtonColor;

  public showSearch = computed(() => this.search.observed && !this.hideSearch());

  public ngOnChanges(): void {
    this.configuration = {
      ...this.defaultConfig,
      ...this.configuration,
    };
  }

  public onSearch(): void {
    this.search.emit(this.searchText);
  }

  public onInputChange(value: string): void {
    this.searchText = value;
    this.search.emit(this.searchText);
  }

  public onClearSearch(): void {
    this.searchText = '';
    this.onSearch();

    this.onInputChange(this.searchText);
  }
}

export interface IContentHeaderConfig {
  searchPlaceholder?: string;
  buttons: IButtonConfig[];
}
